import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import {
	Group as UsersIcon,
	Groups as TeamIcon,
	Assignment as TaskIcon,
	Leaderboard as LeaderboardIcon,
	AssignmentTurnedIn as SubmissionsIcon,
} from "@mui/icons-material";

import jwt from "../utils/jwt.js";

import Tooltip from "./Tooltip.js";

const useStyles = makeStyles((theme) => ({
	sidebar: {
		height: "100%",
		position: "absolute",
		backgroundColor: theme.palette.primary.main,
		color: "white",
		overflow: "auto",
	},
}));

const ButtonWithText = ({ text, icon, handler }) => (
	<span key={text}>
		<Button key={text} sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "8px 40px 8px 16px" }} onClick={(event) => handler(event)}>
			{icon}
			{/* <icon color="white" style={{ width: "25px", height: "25px" }} /> */}
			<Typography align="center" color="white.main" fontSize="medium" ml={1} display="flex" alignItems="center" sx={{ textTransform: "capitalize" }}>
				{text}
			</Typography>
		</Button>
	</span>
);

const ButtonSimple = ({ text, icon, handler, ind }) => (
	<Tooltip title={text}>
		<Button key={text} sx={{ minWidth: "30px!important", padding: "0px", marginTop: (ind === 0) ? "0px" : "10px" }} onClick={(event) => handler(event)}>
			{icon}
			{/* <Image src={icon} alt={text} fit="contain" width="30px" /> */}
		</Button>
	</Tooltip>
);

const Sidebar = ({ isSmall: sidebarIsSmall }) => {
	const [isSmall, setIsSmall] = useState(false);
	const navigate = useNavigate();
	const classes = useStyles();

	useEffect(() => setIsSmall(sidebarIsSmall), [sidebarIsSmall]);

	const buttons = jwt.isAdmin()
		? [
			{
				text: "Users",
				icon: <UsersIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/users",
			},
			{
				text: "Teams",
				icon: <TeamIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/teams",
			},
			{
				text: "Tasks",
				icon: <TaskIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/tasks",
			},
			{
				text: "Submissions",
				icon: <SubmissionsIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/submissions",
			},
			{
				text: "Leaderboard",
				icon: <LeaderboardIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/leaderboard",
			},
		]
		: [
			{
				text: "Team",
				icon: <TeamIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/team",
			},
			{
				text: "Tasks",
				icon: <TaskIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/task",
			},
			{
				text: "Submissions",
				icon: <SubmissionsIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/submission",
			},
			{
				text: "Leaderboard",
				icon: <LeaderboardIcon color="white" style={{ width: "25px", height: "25px" }} />,
				path: "/leaderboard",
			},
		];

	return (
		<div className={classes.sidebar} style={{ width: (isSmall) ? "50px" : "200px", padding: (isSmall) ? "20px 5px" : "20px 5px", textAlign: "center" }}>
			{!isSmall && buttons.map((button) => (
				<ButtonWithText
					key={button.text}
					text={button.text}
					icon={button.icon}
					handler={() => navigate(button.path)}
				/>
			))}
			{isSmall && buttons.map((button, ind) => (
				<ButtonSimple
					key={button.text}
					text={button.text}
					icon={button.icon}
					handler={() => navigate(button.path)}
					ind={ind}
				/>
			))}
		</div>
	);
};

export default Sidebar;
